module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-13.e165f9ad.png";